module.exports = __webpack_public_path__ + "843751c65270fa317f11e4a42c0c5767.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/landing-page/landing-page.html
// module id = 1267
// module chunks = 0